// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hs-form-required {
  color: red;
}

.hubspot-container label {
  display: inline-flex;
  font-size: 14px;
  align-items: baseline;
}

.hubspot-container label span {
  display: inline-flex;
  font-size: 14px;
  align-items: baseline;
  gap: 4px;
}

.hubspot-container .hs-fieldtype-checkbox {
  margin-bottom: 10px;
}

.hubspot-container input[type="submit"] {
  background-color: #0d5cbd;
  color: white;
  margin-top: 10px;
  font-weight: bold;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.hubspot-container input {
  padding: 5px 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.hubspot-container ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.hubspot-container textarea {
  width: 100% !important;
  padding: 5px 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.hubspot-container select {
  width: 100%;
  padding: 5px 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.hubspot-container input[type="radio"] {
  margin-top: 5px;
  margin-bottom: 10px;
}

.hs-error-msgs {
  list-style: none;
  margin: 0 0 10px 0;
  padding: 0;
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/components/partner-with-us/partner-with-us.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ","sourcesContent":[".hs-form-required {\n  color: red;\n}\n\n.hubspot-container label {\n  display: inline-flex;\n  font-size: 14px;\n  align-items: baseline;\n}\n\n.hubspot-container label span {\n  display: inline-flex;\n  font-size: 14px;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.hubspot-container .hs-fieldtype-checkbox {\n  margin-bottom: 10px;\n}\n\n.hubspot-container input[type=\"submit\"] {\n  background-color: #0d5cbd;\n  color: white;\n  margin-top: 10px;\n  font-weight: bold;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.hubspot-container input {\n  padding: 5px 10px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.hubspot-container ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.hubspot-container textarea {\n  width: 100% !important;\n  padding: 5px 10px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.hubspot-container select {\n  width: 100%;\n  padding: 5px 10px;\n  margin-top: 5px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\n.hubspot-container input[type=\"radio\"] {\n  margin-top: 5px;\n  margin-bottom: 10px;\n}\n\n.hs-error-msgs {\n  list-style: none;\n  margin: 0 0 10px 0;\n  padding: 0;\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
